import { BASE_URL } from '../utils/apiUtils';
import { HttpService } from './HttpService';

export const FeeService = () => {
	const { get, patch, post, put, deleteFn } = HttpService();

	const postFee = (body) => {
		const url = `${BASE_URL}/api/fee`;
		return post(url, body, 'postFee', {});
	};

	const postPreliminaryFee = (body, caseId) => {
		const url = `${BASE_URL}/api/preliminary-fees/case/${caseId}`;
		return post(url, body, 'postFee', {});
	};

	const postTransferPreliminaryFees = (body) => {
		const url = `${BASE_URL}/api/fee/preliminary-fees`;
		return post(url, body, 'postTransferPreliminaryFees', {});
	};

	const postFeeGroup = (body) => {
		const url = `${BASE_URL}/api/fees/fee-group`;
		return post(url, body, 'postFeeGroup', {});
	};

	const getFees = (page, size) => {
		const url = `${BASE_URL}/api/fee/codes?page=${page}&size=${size}`;
		return get(url, 'getFees', {});
	};

	const getFeeCodes = () => {
		const url = `${BASE_URL}/api/fee/codes`;
		return get(url, 'getFeeCodes', []);
	};

	const postFeeCode = (body) => {
		const url = `${BASE_URL}/api/fee/code`;
		return post(url, body, 'postFeeCode', {});
	};

	const putFeeCode = (feeCodeId, body) => {
		const url = `${BASE_URL}/api/fee/code/${feeCodeId}`;
		return put(url, body, 'putFeeCode', {});
	};

	const deletePreliminaryFee = (preliminaryFeeId) => {
		const url = `${BASE_URL}/api/preliminary-fees/${preliminaryFeeId}`;
		return deleteFn(url, 'deletePreliminaryFee', {});
	};
	const deleteFeeCode = (feeCode) => {
		const url = `${BASE_URL}/api/fee/code/${feeCode}`;
		return deleteFn(url, 'deleteFeeCode', {});
	};

	const deleteFee = (feeId) => deleteFn(`${BASE_URL}/api/fee/${feeId}`, 'deleteFee', {});

	const getFeesGroups = () => {
		const url = `${BASE_URL}/api/fee-group-code-management/group-codes`;
		return get(url, 'getFeesGroups', []);
	};

	const postFeeCodeGroup = (body) => {
		const url = `${BASE_URL}/api/fee-group-code-management/group`;
		return post(url, body, 'postFeeCodeGroup', {});
	};

	const putFeeCodeGroup = (body, feeGroupCodeId) => {
		const url = `${BASE_URL}/api/fee-group-code-management/group/${feeGroupCodeId}`;
		return put(url, body, 'putFeeCodeGroup', {});
	};

	const deleteFeeCodeGroup = (feeCode, body) => {
		const url = `${BASE_URL}/api/fee-group-code-management/group/${feeCode}`;
		return patch(url, body, 'deleteFeeCodeGroup', {});
	};

	const activateFeeCodeGroup = (feeCodeId, body) => {
		const url = `${BASE_URL}/api/fee-group-code-management/group/${feeCodeId}/active`;
		return patch(url, body, 'activateFeeCodeGroup', {});
	};

	const getPriorityFees = () => {
		const url = `${BASE_URL}/api/code-table-management/code-tables/categories/fee_code_priority`;
		return get(url, 'getPriorityFees', []);
	};

	const getTimesApplied = () => {
		const url = `${BASE_URL}/api/code-table-management/code-tables/categories/fee_code_times_applied`;
		return get(url, 'getTimesApplied', []);
	};

	const putAdjustFee = (body, caseId, partyId) => {
		const url = partyId
			? `${BASE_URL}/api/fees/case/${caseId}/party/${partyId}/amount`
			: `${BASE_URL}/api/fees/case/${caseId}/amount`;
		return put(url, body, 'putFee', {});
	};

	const getFeeTotal = (caseId, partyId) => {
		const url = partyId
			? `${BASE_URL}/api/fees/case/${caseId}/party/${partyId}/amount`
			: `${BASE_URL}/api/fees/case/${caseId}/amount`;
		return get(url, 'getFeeTotal', {});
	};

	const postReversePayment = (body, paymentId) => {
		const url = `${BASE_URL}/api/payment/${paymentId}/reverse`;
		return post(url, body, 'postReversePayment', {});
	};

	const getFeesPartiesStatus = (caseId) => {
		const url = `${BASE_URL}/api/fee/parties/case/${caseId}/status`;
		return get(url, 'getFeesPartiesStatus', {});
	};

	const getFeesForParty = (caseId, partyId) => {
		const url = `${BASE_URL}/api/fees/history/case/${caseId}/party/${partyId}?page=0&size=1000`;
		return get(url, 'getFeesForParty', {});
	};

	const getFeeCodeGroup = (caseId) => {
		const url = `${BASE_URL}/api/fee-group-code-management/case/${caseId}/groups`;
		return get(url, 'getFeeCodeGroup', []);
	};
	const putFeeEdit = (body, feeId) => {
		const url = `${BASE_URL}/api/fee/${feeId}`;
		return put(url, body, 'putFeeEdit', {});
	};

	const getAGTypes = () => {
		const url = `${BASE_URL}/api/code-table-management/code-tables/categories/ag_type`;
		return get(url, 'getAGTypes', []);
	};
	const getStateCostReport = (caseCategoryCode, repealed) => {
		const url = `${BASE_URL}/api/state-cost-report?caseCategoryCode=${caseCategoryCode}&repealed=${repealed} `;
		return get(url, 'getStateCostReport', []);
	};
	const getMoneyDistribution = () => {
		const url = `${BASE_URL}/api/financial/money-distribution/clerk`;
		return get(url, 'getMoneyDistribution', []);
	};
	const getCategory = () => {
		const url = `${BASE_URL}/api/code-table-management/code-tables/categories/case_category`;
		return get(url, 'getCategory', []);
	};

	const getSelectedMoneyDistribution = (feeCodeId, clerkId) => {
		const url = `${BASE_URL}/api/financial/money-distribution-fee/fee-code-id/${feeCodeId}${
			clerkId ? `?clerk=${clerkId}` : ''
		}`;
		return get(url, 'getMoneyDistribution', {});
	};

	const getCategoryFeeCode = () => {
		const url = `${BASE_URL}/api/code-table-management/code-tables/categories/case_category/financial?`;
		return get(url, 'getCategoryFeeCode', []);
	};

	const getTotalFees = (caseId, partyId) => {
		const url = `${BASE_URL}/api/fees/totals/case/${caseId}${
			!partyId ? '/party?partyId' : `/party?partyId=${partyId}`
		}`;

		return get(url, 'getTotalFees', []);
	};

	const getFeeById = (feeId) => {
		const url = `${BASE_URL}/api/fee/${feeId}`;
		return get(url, 'getFeeById', []);
	};

	const putFeesDueDate = (body) => {
		const url = `${BASE_URL}/api/fee/dueDate`;
		return put(url, body, 'putFeesDueDate', {});
	};

	return {
		postFee,
		postPreliminaryFee,
		postTransferPreliminaryFees,
		postFeeGroup,
		getFees,
		getFeeCodes,
		getFeeTotal,
		postFeeCode,
		putFeeCode,
		deleteFee,
		deleteFeeCode,
		deletePreliminaryFee,
		getFeesGroups,
		postFeeCodeGroup,
		putFeeCodeGroup,
		deleteFeeCodeGroup,
		activateFeeCodeGroup,
		getSelectedMoneyDistribution,
		getPriorityFees,
		getTimesApplied,
		putAdjustFee,
		postReversePayment,
		getFeeCodeGroup,
		putFeeEdit,
		getFeesPartiesStatus,
		getFeesForParty,
		getAGTypes,
		getStateCostReport,
		getMoneyDistribution,
		getCategory,
		getCategoryFeeCode,
		getTotalFees,
		getFeeById,
		putFeesDueDate
	};
};
